import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, CONTACT } from "@/lib/site-data";
import { scrollToSection, scrollToTop } from "@/lib/scroll";

const Footer = () => {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-ink-soft/40">
      <div className="mx-auto max-w-[1440px] px-6 py-16 md:px-12 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          {/* Brand */}
          <div>
            <button onClick={scrollToTop} className="flex items-center" aria-label="Yas Solutions home">
              <img
                src={`${process.env.PUBLIC_URL || ""}/logo.png`}
                alt="Yas Solutions"
                className="h-16 w-auto"
              />
            </button>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/55">
              A web design & development studio helping small businesses, entrepreneurs
              and local companies grow with fast, modern, custom-built websites.
            </p>
          </div>

          {/* Nav */}
          <div>
            <p className="font-heading text-sm font-semibold uppercase tracking-wider text-white/40">
              Navigate
            </p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => (link.id === "home" ? scrollToTop() : scrollToSection(link.id))}
                    data-testid={`footer-link-${link.id}`}
                    className="text-sm text-white/60 transition-colors hover:text-white"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-heading text-sm font-semibold uppercase tracking-wider text-white/40">
              Connect
            </p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-connect-email"
                  className="text-sm text-white/60 transition-colors hover:text-white"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <span
                  data-testid="footer-connect-phone"
                  className="text-sm text-white/60"
                >
                  {CONTACT.phone}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Yas Solutions. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" data-testid="footer-privacy" className="text-xs text-white/40 transition-colors hover:text-white">
              Privacy Policy
            </a>
            <a href="#" data-testid="footer-terms" className="text-xs text-white/40 transition-colors hover:text-white">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
